// extracted by mini-css-extract-plugin
module.exports = {"base":"MediaEmbed_base___VyrL","mediaCaption":"MediaEmbed_mediaCaption__hefAt"};